import { PropsWithChildren } from "react";
import { BiCommonDataContext, BiCommonDataContextType } from "./BiCommonDataContext";

export const BiCommonDataContextProvider = ({ children, ...props }: PropsWithChildren<BiCommonDataContextType>) => (
  <BiCommonDataContext.Provider value={props}>{children}</BiCommonDataContext.Provider>
);
